@if (formGroup && filters && filters.length > 0) {
  <div>
    <form
      [formGroup]="formGroup"
      class="filters-form"
      (submit)="submit()"
      style="background-color: rgba(127, 127, 127, 0.1); border-radius: 8px; margin-bottom: 6px; position: relative">
      <div style="display: flex; flex-wrap: wrap" [hidden]="!filterOn">
        @for (filter of filters; track filter) {
          <div style="min-width: 200px; max-width: 300px; margin: 6px 10px">
            <span>{{ filter.label }}</span>
            <app-form-field
              [data]="filter.value"
              [type]="filter.type"
              [fieldConfig]="filter"
              [editMode]="true"
              [formGroup]="formGroup"></app-form-field>
          </div>
        }
      </div>
      @if (elasticFilter) {
        <div>
          <div style="margin: 6px 10px">
            <mat-form-field style="width: 100%">
              <mat-label>Elastic filter</mat-label>
              <input data-id="inputElasticFilter" matInput formControlName="ELASTIC_FILTER" />
            </mat-form-field>
          </div>
          <div style="min-height: 20px">
            @for (filterDef of elasticFilters; track filterDef) {
              <span
                class="quick-filter"
                [ngStyle]="filterDef.ngStyle"
                (click)="elasticFilterClicked(filterDef)"
                (dblclick)="elasticFilterDoubleClicked(filterDef)"
                matTooltip="{{ filterDef.description || filterDef.queryString }}">
                {{ filterDef.label }}
              </span>
            }
          </div>
        </div>
      }
      <div
        [hidden]="!filterOn && !elasticFilter"
        style="display: flex; justify-content: flex-end; position: absolute; bottom: 2px; right: 20px">
        <button
          data-id="filterSearchBtn"
          type="submit"
          mat-icon-button
          color="primary"
          style="margin-right: 10px"
          [disabled]="formGroup.invalid">
          <mat-icon>search</mat-icon>
        </button>
        <button type="reset" mat-icon-button="" color="warn" type="reset" (click)="reset()">
          <mat-icon>cancel</mat-icon>
        </button>
      </div>
    </form>
  </div>
}
